import type { ReactNode } from 'react'
import type { AuthProviderProps as OidcAuthProviderProps } from 'react-oidc-context'
import { AuthProvider as OidcAuthProvider } from 'react-oidc-context'
import { useAppConfig } from '@/hooks/use-appConfig'
import { ensureSlash } from '@/lib/ensure-slash'

export interface AuthProviderProps {
	children: ReactNode
}

export {
	type AuthProviderProps as OidcAuthProviderProps,
	useAuth as useOidcAuth,
} from 'react-oidc-context'

export function AuthProvider({ children }: Readonly<AuthProviderProps>) {
	const config = useAppConfig()

	const oidcConfig = config.oidc
		? ({
				authority: config.oidc.issuerUri,
				client_id: config.oidc.clientId,
				scope: config.oidc.scope,
				redirect_uri:
					config.oidc.redirectUri ||
					`${globalThis.location.origin}${ensureSlash(globalThis.__BASE_URL)}auth`,
				silent_redirect_uri: `${globalThis.location.origin}${ensureSlash(globalThis.__BASE_URL)}auth/silent`,
				post_logout_redirect_uri: `${globalThis.location.origin}${ensureSlash(globalThis.__BASE_URL)}`,
				response_type: 'code',
				automaticSilentRenew: true,
				onSigninCallback() {
					if (!globalThis.opener) return

					// Close the popup globalThis after login
					globalThis.close()
				},
				onSignoutCallback() {
					if (!globalThis.opener) return

					// Close the popup globalThis after logout
					globalThis.close()
				},
			} satisfies OidcAuthProviderProps)
		: {}

	return <OidcAuthProvider {...oidcConfig}>{children}</OidcAuthProvider>
}
